import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';

@Component({
    selector: 'app-time-selector',
    templateUrl: './time-selector.component.html',
    styleUrls: ['./time-selector.component.scss'],
    standalone: false
})
export class TimeSelectorComponent implements OnInit, OnDestroy {
  @Output() timesChanged = new EventEmitter();
  @Input() initialStart: string = '';
  @Input() initialEnd: string = '';

  timeForm: FormGroup;
  private destroy$ = new Subject<void>();

  constructor(private fb: FormBuilder) {
    this.timeForm = this.fb.group({
      start: ['', Validators.required],
      end: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    this.timeForm.patchValue(
      {
        start: this.initialStart || '',
        end: this.initialEnd || '',
      },
      {emitEvent: false},
    );

    this.timeForm.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => this.emitTimes());
  }

  emitTimes(): void {
    if (this.timeForm.valid) {
      const {start, end} = this.timeForm.value;
      this.timesChanged.emit({start, end});
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
